import React from "react";
import "./TaskDetail.scss";
import Skeleton from "../../../../components/tasks/elementalUI/skeleton/Skeleton";

const TaskDetailSkeleton = () => {
  return (
    <div className="taskdetail-section skeleton-scroll">
      <div className="taskdetail-skeleton-title">
        <Skeleton height="44px" width="100%" />
      </div>
      <div className="taskdetail-skeleton-header">
        <div className="taskdetail-skeleton-left-section">
          <Skeleton height="27px" width="85px" />
          <Skeleton height="27px" width="105px" />
          <Skeleton height="27px" width="250px" />
        </div>
        <div className="taskdetail-skeleton-right-section">
          <Skeleton height="27px" width="150px" />
        </div>
      </div>
      <div className="taskdetail-skeleton-body">
        <div className="taskdetail-skeleton-leftsection">
          <Skeleton height="30px" width="80%" />
          <Skeleton height="30px" width="80%" />
          <Skeleton height="30px" width="80%" />
          <Skeleton height="30px" width="80%" />
          <Skeleton height="30px" width="80%" />
        </div>
        <div className="taskdetail-skeleton-rightsection">
          <Skeleton height="30px" width="80%" />
          <Skeleton height="30px" width="80%" />
          <Skeleton height="30px" width="80%" />
          <Skeleton height="30px" width="80%" />
          <Skeleton height="30px" width="80%" />
        </div>
      </div>
      <div className="taskdetail-skeleton-description">
        <Skeleton height="15px" width="20%" className="my-2" />
        <Skeleton height="15px" width="100%" />
        <Skeleton height="15px" width="100%" />
        <Skeleton height="15px" width="100%" />
        <Skeleton height="15px" width="100%" />
        <Skeleton height="15px" width="100%" />
        <Skeleton height="15px" width="100%" />
        <Skeleton height="15px" width="100%" />
        <Skeleton height="15px" width="100%" />
        <Skeleton height="15px" width="100%" />
        <Skeleton height="15px" width="100%" />
        <Skeleton height="15px" width="100%" />
        <Skeleton height="15px" width="100%" />
        <Skeleton height="15px" width="100%" />
        <Skeleton height="15px" width="100%" />
        <Skeleton height="15px" width="100%" />
        <Skeleton height="15px" width="100%" />
        <Skeleton height="15px" width="100%" />
      </div>
    </div>
  );
};

export default TaskDetailSkeleton;
